import * as React from 'react'

import { SchoolPage_school } from 'main/pages/School/gql'
import { Container } from './LicenseInformation.styles'
import LicenseInformationSection from './LicenseInformationSection'

interface IProps {
  school: SchoolPage_school
}

export default function LicenseInformation(props: IProps) {
  const { school } = props

  if (!school) return null

  return (
    <Container>
      <Content {...props} />
    </Container>
  )
}

function Content(props: IProps) {
  const { school } = props

  if (school && school.__typename === 'School') {
    return <LicenseInformationSection school={school} />
  } else return null
}
